import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const myCompaniesService = {
  all(params) {
    const queries = params ? '?' + params : '';
    return fetch(`/api/my/companies${queries}`, request.get);
  }
};
export default myCompaniesService;